import React from "react";

export function Mascot({ size = 96, float = true, className = "" }) {
  return (
    <img
      src="/brand/gv-mascot.png"
      alt="Studio mascot"
      style={{ width: size, height: size }}
      className={`object-contain ${float ? "animate-float" : ""} ${className}`}
      data-testid="studio-mascot"
    />
  );
}

export function MascotBubble({ message, size = 88 }) {
  return (
    <div className="flex items-end gap-3" data-testid="studio-bubble">
      <Mascot size={size} />
      <div className="glass rounded-2xl rounded-bl-sm px-4 py-3 max-w-sm shadow-lg">
        <p className="text-sm font-medium leading-relaxed">{message}</p>
      </div>
    </div>
  );
}
